/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {KTIcon} from '../../../helpers'
import {useAuth } from '../../../../app/modules/auth'
import { BLACKBOXES_GET_DEVICE_LIST_SIZE_URL } from '../../../../urls'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string
}

const BlackboxDeviceNumberWidget: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  titleColor,
  description,
  descriptionColor,
}) => {
  
  const {currentUser, logout} = useAuth()
  const token = currentUser?.token
  // Kart uc durumu AYIRT EDIYOR: yukleniyor / deger / bilinmiyor.
  //
  // Eskiden state `useState(0)` ile basliyordu ve hata durumunda degismiyordu; isNumber(0)
  // true oldugu icin ekranda "0" ya da "0.00 kg" yaziyordu -- yani gercek bir olcum gibi
  // gorunen yanlis bir sayi. Bozuk oldugu belli olmuyordu. 2026-10-07 pano gezintisi.
  const [blackboxNumber, setBlackboxNumber] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)

  const createHeader = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', "" + token?.toString());
    return headers
}

  useEffect(() => {
    getBlackboxNumber()
  },[]) 

  async function getBlackboxNumber() {
    try{
    const response = await fetch(BLACKBOXES_GET_DEVICE_LIST_SIZE_URL+`?role=${currentUser?.role}&id=${currentUser?.id}`,{
      method:"GET",
      headers: createHeader()
    });
    if (response.status === 401) {
      logout();
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`)
    }
    const data = await response.json();
    setBlackboxNumber(typeof data === 'number' ? data : null)
  } catch (error) {
    console.error("Error fetching blackbox details:", error);
    setBlackboxNumber(null)
  } finally {
    setLoading(false)
  }
  }
  function isNumber(value) {
    return typeof value === 'number';
  }

  return (
    <a href='#' className={`card bg-${color} hoverable ${className}`}>
      <div className='card-body'>
        <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1`} />

        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>Toplam Cihaz Sayısı : 
        {loading ? "yükleniyor…" : isNumber(blackboxNumber) ? blackboxNumber : "bilinmiyor"}</div>

        <div className={`fw-semibold text-${descriptionColor}`}>Sistemde toplam kayıtlı cihaz sayısı</div>
      </div>
    </a>
  )
}

export {BlackboxDeviceNumberWidget}
